import {
  useStyle 
} from "@/classify"
import defaultClasses from "./trigger.module.css"

const Trigger = (props) => {
  const {
    action,
    children,
    ariaLabel,
    classes: propClasses,
    ...restProps
  } = props

  const classes = useStyle(defaultClasses, propClasses)

  return (
    <button
      className={classes.root}
      type='button'
      onClick={action}
      aria-label={ariaLabel}
      {...restProps}
    >
      {children}
    </button>
  )
}

export default Trigger
